document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function() {  
    $('.extras-wrap').prepend('<div onclick="shoptet.modal.close();" class="extra btn btn-secondary">Zpět do obchodu</div>')  
    $('.h1.advanced-order-suggestion').text('Doporučujeme přikoupit')
})


document.addEventListener('ShoptetDOMCartContentLoaded', function() { 
    
    $('.cart-widget-product').each(function(){
        $(this).find('.cart-widget-product-name').append('<span class="amountProduct">'+$(this).find('.cart-widget-product-amount input.amount').val()+' '+$(this).find('.cart-widget-product-unit').text()+'</span>')
    })

})

if($('.id--16, .id--17').length){
    $.get('/action/Cart/GetCartContent/?orderingProcessActive=1', function(data){   
        $('.cart-item[data-micro="cartItem"]').each(function(){
            get_id = $(this).attr('data-micro-sku')
            link = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image a').attr('href')
            image = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image img').attr('data-src').replace('related', 'detail')
            if(!$(this).find('.right').length){
                $(this).wrapInner('<div class="right"></div>')
                $(this).prepend('<div class="image"><a href="'+link+'"><img src="'+image+'" alt="'+$(this).find('a[data-testid="recapItemName"]').text()+'"></a></div>')
            }
        })
    })
    $('.cart-inner').prepend($('.cart-header'))
}

if($('.id--9').length){
    const storageKey = window.location.host + "-productData";
    function fetchDataAndStore() {
        $.getJSON("/user/documents/isbn.json", function (data) {
            sessionStorage.setItem(storageKey, JSON.stringify(data));
            updateCartAvailability(data);
        }).fail(function () {
            console.error("❌ Chyba: Nelze načíst JSON soubor.");
        });
    }
    function formatCzechDate(dateString) {
        if (!dateString || !/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
            return dateString;
        }
        let [year, month, day] = dateString.split("-");
        return `${parseInt(day, 10)}.${parseInt(month, 10)}.${year}`;
    }
    function updateCartAvailability(data) {
        $(".removeable").each(function () {
            let productSku = $(this).attr("data-micro-sku");
            let match = data.find(item => item.code === productSku);

            if (match) {
                let formattedDate = formatCzechDate(match.productNumber);
                let availabilityCell = $(this).find(".p-availability");
                if (!availabilityCell.find(".deliveryDateJSON").length) {
                    availabilityCell.append(`<span class="deliveryDateJSON" style="display:block;">naskladnění od ${formattedDate}</span>`);
                }

                console.log(`✅ Nalezeno: ${match.code} -> Naskladnění: ${formattedDate}`);
            }
        });
    }
    const storedData = sessionStorage.getItem(storageKey);
    if (storedData) {
        console.log("✅ Načteno ze storage.");
        updateCartAvailability(JSON.parse(storedData));
    } else {
        console.log("🔄 Načítám data z JSON souboru...");
        fetchDataAndStore();
    }
    function mhProductInfoMove(){
        $('.cart-table tr').each(function(){
          var findcenazakus = $(this).find('.p-price.p-cell').html();
          var findptotal = $(this).find('.p-total');
          $(this).find('.p-name').append('<div class="avail">'+$(this).find('.p-availability').html()+'</div>')
          $(findptotal).prepend('<span class="cenazaks">'+findcenazakus+'</span>');
        })
    };
    mhProductInfoMove()
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        mhProductInfoMove();
    });
}

if($('.id--17').length){
//    $('.cart-content>.co-contact-information .phone-form-group').after($('.form-group label[for="login"]').closest('.form-group'))
}

if($('.id--16').length){

    var customDeliverySplit = '<div class="co-box co-split-delivery-method">'
    customDeliverySplit += '<h4 class="order-icon order-delivery">Chci si rozdělit objednávku</h4>'
        customDeliverySplit += '<p>V košíku máte produkt, co má dodací dobu na objednání. Chcete objednávku poslat na části?</p>'
        customDeliverySplit += '<div id="order-split-delivery-methods" class="split-delivery-billing-table">'
            customDeliverySplit += '<div class="splitDelivery" data-code="'+splitDeliveryCode+'">'
                customDeliverySplit += '<div class="image"><img src="'+splitDeliveryImg+'" alt="rozdělit objednávku"></div>'
                customDeliverySplit += '<div class="name">Chci si rozdělit objednávku <small></small></div>'
                if(getShoptetDataLayer('currency') === 'CZK'){
                    customDeliverySplit += '<div class="payment">'+Number(splitDeliveryPrizeCZK).ShoptetFormatAsCurrency();+'</div>'
                }
                if(getShoptetDataLayer('currency') === 'EUR'){
                    customDeliverySplit += '<div class="payment">'+Number(splitDeliveryPrizeEUR).ShoptetFormatAsCurrency();+'</div>'
                }
                
            customDeliverySplit += '</div>'
            customDeliverySplit += '</div>'
            customDeliverySplit += '<div class="splitDelivery active"  data-code="0">'
                customDeliverySplit += '<div class="image"><img src="'+deliveryImg+'" alt="nerozdělit objednávku"></div>'
                customDeliverySplit += '<div class="name">Nechci objednávku rozdělovat</div>'
                customDeliverySplit += '<div class="payment free">Zdarma</div>'
            customDeliverySplit += '</div>'
        customDeliverySplit += '</div>'
    customDeliverySplit += '</div>'



    const storageKey = window.location.host+"-productData";
    function fetchDataAndStore() {
        $.getJSON("/user/documents/isbn.json", function (data) {
            sessionStorage.setItem(storageKey, JSON.stringify(data));
            checkCartItems(data);
        }).fail(function () {
            console.error("❌ Chyba: Nelze načíst JSON soubor.");
        });
    }
    function checkCartItems(data) {
        let cartItems = $(".cart-items .cart-item");
        let foundInJson = 0;
        let notFoundInJson = 0;
        cartItems.each(function () {
            let productCode = $(this).attr("data-micro-sku");
            if (!productCode) {
                console.warn("⚠️ Varování: Produkt v košíku nemá SKU.");
                return;
            }
            let match = data.find(item => item.code === productCode);
            if (match) {
                foundInJson++;
            } else {
                notFoundInJson++;
            }
        });
        if (foundInJson > 0 && notFoundInJson > 0) {
            $('.co-box.co-delivery-method').after(customDeliverySplit)
        } else {
            console.log("✅ Všechny produkty jsou buď v JSON, nebo nejsou.");
        }
    }
    const storedData = sessionStorage.getItem(storageKey);
    if (storedData) {
        console.log("✅ Načteno ze storage.");
        checkCartItems(JSON.parse(storedData));
    } else {
        console.log("🔄 Načítám data z JSON souboru...");
        fetchDataAndStore();
    } 

    $('html').on('click', '.splitDelivery', function () {
        let productCode = $(this).data('code');
        $('.splitDelivery').removeClass('active');
        $(this).addClass('active');
        let cartData = getShoptetDataLayer('cart');
        if (!cartData || cartData.length === 0) {
            console.error("❌ Chyba: Nelze získat data z košíku.");
            return;
        }
        let cartItem = cartData.find(item => item.code === splitDeliveryCode.toString());
        let itemId = cartItem ? cartItem.itemId : null;
        if (productCode > 0) {
            shoptet.cartShared.addToCart({ productCode: productCode }, true);
            console.log(`✅ Přidán produkt s priceId: ${productCode}`);
            addProducts();

        } else if (itemId) {
            shoptet.cartShared.removeFromCart({ itemId: itemId });
            console.log(`❌ Odebrán produkt s itemId: ${itemId}`);
            deleteProducts();
        } else {
            console.warn("⚠️ Varování: Produkt s priceId 0 nebyl v košíku nalezen.");
        }
    });
    $(document).ready(function () {
        let cartItems = $(".cart-items .cart-item");
        let foundInCart = false;
        cartItems.each(function () {
            let productSku = $(this).attr("data-micro-sku");
            if (productSku.toString() === splitDeliveryCode.toString()) {
                foundInCart = true;
                return false;
            }
        });
        if (foundInCart) {
            $(".splitDelivery").each(function () {
                let code = $(this).attr("data-code");
                if (code.toString() === splitDeliveryCode.toString()) {
                    $(this).addClass("active");
                } else {
                    $(this).removeClass("active");
                }
            });
            console.log(`✅ Nastaveno jako aktivní: .splitDelivery[data-code="${splitDeliveryCode}"]`);
        } else {
            console.log("❌ Produkt s data-micro-sku='268861' nebyl nalezen v košíku.");
        }
    });

    function addProducts(){
        document.addEventListener('ShoptetCartUpdated', function() {
            addCartItems();  
            pricesProducts();          
        }, { once: true });      
    }

    function deleteProducts(){
        document.addEventListener('ShoptetCartUpdated', function() {
            console.log(getShoptetDataLayer('cart'));
            cleanCartItems();
            pricesProducts();
        }, { once: true });        
    }
}

function cleanCartItems() {
    let cartData = getShoptetDataLayer('cart');
    if (!cartData || cartData.length === 0) {
        console.warn("⚠️ Košík je prázdný nebo nelze získat data.");
        return;
    }
    let validSkus = cartData.map(item => item.code);
    $(".cart-items .cart-item").each(function () {
        let productSku = $(this).attr("data-micro-sku");
        if (!validSkus.includes(productSku)) {
            let itemId = $(this).attr("data-micro-identifier");
            if (itemId) {
              $(this).remove() 
            } else {
                
            }
        }
    });
}


function addCartItems() {
    let cartData = getShoptetDataLayer('cart');
    if (!cartData || cartData.length === 0) {
        console.warn("⚠️ Košík je prázdný nebo nelze získat data.");
        return;
    }
    let displayedSkus = $(".cart-items .cart-item").map(function () {
        return $(this).attr("data-micro-sku");
    }).get();
    let missingItems = cartData.filter(item => !displayedSkus.includes(item.code));
    if (missingItems.length > 0) {
        missingItems = missingItems[0]
        $('.cart-items').append('<div class="cart-item" data-micro="cartItem" data-micro-identifier="'+missingItems.guid+'" data-micro-sku="'+missingItems.code+'" data-testid="recapCartItem"><div class="image"><img src="'+$('#order-split-delivery-methods .splitDelivery[data-code="'+missingItems.code+'"] img').attr('src')+'" alt=""></div><div class="right"><div class="cart-item-name" data-testid="recapItemName"><a href="#" class="main-link" data-testid="cartProductName">'+missingItems.name+'</a></div><div class="cart-item-amount" data-testid="recapItemAmount">'+missingItems.quantity+'<span class="unit-value">ks</span></div><div class="cart-item-price" data-testid="recapItemPrice">'+Number(missingItems.priceWithVat).ShoptetFormatAsCurrency()+'</div></div></div>')
    } else {
        console.log("✅ Všechny produkty z datalayer jsou v HTML košíku.");
    }
}

function pricesProducts(){
    var prizeproductwithvat = getShoptetDataLayer('cartInfo').getNoBillingShippingPrice.withVatUnrounded
    var prizeProductVat = getShoptetDataLayer('cartInfo').getNoBillingShippingPrice.vat
    var prizeWithoutVat = getShoptetDataLayer('cartInfo').getNoBillingShippingPrice.withoutVat
    let totalWithVat = 0;
    let totalWithoutVat = 0;
    let totalVat = 0;
    $('.shipping-billing-table#order-shipping-methods .radio-wrapper.active').each(function () {
        let shippingWithVat = parseFloat($(this).find('.payment-shipping-price').attr('data-shipping-price-wv')) || 0;
        
        let shippingWithoutVat = parseFloat($(this).find('.payment-shipping-price').attr('data-shipping-price-wov')) || 0;
        let shippingVat = parseFloat($(this).find('.payment-shipping-price').attr('data-shipping-price-vat')) || 0;
        totalWithVat += shippingWithVat;
        totalWithoutVat += shippingWithoutVat;
        totalVat += shippingVat;
    });
    $('.shipping-billing-table#order-billing-methods .radio-wrapper.active').each(function () {
        let billingWithVat = parseFloat($(this).find('.payment-shipping-price').attr('data-billing-price-wv')) || 0;
        let billingWithoutVat = parseFloat($(this).find('.payment-shipping-price').attr('data-billing-price-wov')) || 0;
        let billingVat = parseFloat($(this).find('.payment-shipping-price').attr('data-billing-price-vat')) || 0;
        totalWithVat += billingWithVat;
        totalWithoutVat += billingWithoutVat;
        totalVat += billingVat;
    });
    $('.order-summary-item.helper div[data-testid="recapItemTotalPrice"]').html(Number(prizeproductwithvat).ShoptetFormatAsCurrency())
    $('.price.price-primary>span').attr('data-price-total-wv', prizeproductwithvat).attr('data-price-total-vat', prizeProductVat).text(Number(prizeproductwithvat+totalWithVat).ShoptetFormatAsCurrency())
    $('.price.price-secondary').attr('data-price-total-wov', prizeWithoutVat).text(Number(prizeWithoutVat+totalWithoutVat).ShoptetFormatAsCurrency())
}

